module.exports = __webpack_public_path__ + "toBride2-we-w-n.2fe22245.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride2-we-w-n.jpg
// module id = zF9q
// module chunks = 0